<p-toast
  key="message"
  position="top-right"></p-toast>
<p-confirmDialog
  styleClass="frm-confirm-dialog-v2"
  acceptIcon="pi pi-check"
  rejectIcon="pi pi-times"
  acceptButtonStyleClass="frm-confirm-dialog-v2__accept"
  rejectButtonStyleClass="frm-confirm-dialog-v2__reject"
  [style]="{ width: '90%', maxWidth: '450px' }"
  [baseZIndex]="10000"></p-confirmDialog>
<p-scrollTop
  [threshold]="600"
  icon="pi pi-arrow-up"></p-scrollTop>

<router-outlet></router-outlet>
